import React from 'react';
import { Link } from 'react-router-dom';

const TransparentBtn = ({ to, text }) => {
  return (
    <Link to={to} className="ghostBtn44">
      <span>{text}</span>
    </Link>
  );
};
export default TransparentBtn;
